module.exports = __webpack_public_path__ + "static/media/introscr.013bc9fb.jpg";